<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-07-28 17:37:34
 * @LastEditors: sjq
 * @LastEditTime: 2023-08-08 15:08:28
 -->
<template>
  <div class="minheight100">
    <app-header v-if="appUser.isNative" back-type="back-app" title="我的订单"></app-header>
    <div class="order-main">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text=""
          offset="10"
          @load="getData"
        >
          <div v-for="item in orderList" :key="item.courseId" class="order-item">
            <div class="sn">
              <span>
                {{ item.orderSn }}
              </span>
              <img @click="copyText(item.orderSn, $event)" src="../../images/copy_icon.png" class="img" alt="" />
            </div>
            <div class="goods-name">
              <span>
                {{ item.goodsName }}
              </span>
              <span class="tag" v-if="item.goodsTag">{{ item.goodsTag }}</span>
            </div>
            <div class="time">
              {{ item.orderTime }}
            </div>
            <div class="order-status">
              <div>
                实付
                <span class="amount">¥ {{ item.realPayAmount }}</span>
              </div>
              <span class="status">{{ item.orderStatusName }}</span>
            </div>
          </div>
          <div v-if="orderList.length == 0 && !loading" class="no-list">
            <img src="../../images/integral/no_list.png" alt="" />
            <div class="commit">暂无订单</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import { orderListService } from '@/api'
import { Indicator } from 'mint-ui'
import copyText from '@/utils/clipboard'

const action = 'orderList'

export default {
  name: action,
  components: {
    Popup
  },
  data() {
    return {
      appUser,
      title: '友邻少年',
      loading: false,
      refreshing: false,
      finished: false,
      page: 0,
      totalList: 0,
      dataDetail: true,
      orderList: [],
      copyText
    }
  },
  mixins: [Body],
  created() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  activated() {},
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mounted() {},

  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      setTimeout(() => {
        this.getData()
      })
    },
    //详情
    getData() {
      this.page += 1
      orderListService
        .getOrderList({
          currentPage: this.page,
          pageSize: 10
        })
        .then(res => {
          Indicator.close()
          if (this.refreshing) {
            this.refreshing = false
          }
          const { list, total } = res
          this.totalList = total
          this.loading = false
          this.isLoading = false

          if (this.page === 1) {
            this.orderList = list
          } else {
            this.orderList = this.orderList.concat(list)
          }
          if (this.orderList.length === total) {
            this.finished = true
          }
        })
        .catch(() => {
          Indicator.close()
        })
    },
    onRefresh() {
      this.page = 0
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.orderList = []
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.order-main {
  padding: 0.32rem;
  background: #f5f5f5;
  .order-item {
    background: #fff;
    padding: 0.32rem;
    border-radius: 0.16rem;
    margin-bottom: 0.32rem;
    .sn {
      color: #999;
      margin-bottom: 0.28rem;
      display: flex;
      align-items: center;
      .img {
        width: 0.32rem;
        height: 0.32rem;
        margin-left: 0.08rem;
      }
    }
    .goods-name {
      font-size: 0.32rem;
      font-weight: bold;
      margin-bottom: 0.16rem;
      line-height: 1.2;
      .tag {
        border-radius: 0.04rem;
        border: 1px solid #999;
        padding: 0px 0.08rem;
        color: #999;
        font-size: 0.24rem;
        font-weight: 400;
        display: inline-block;
      }
    }
    .time {
      color: #999;
      font-size: 0.24rem;
      margin-bottom: 0.24rem;
    }
    .order-status {
      padding-top: 0.24rem;
      border-top: dashed 1px #ccc;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .amount {
        color: #00b25a;
      }
      .status {
        color: #999;
      }
    }
  }
}
.no-list {
  text-align: center;
  margin: 1rem 0;
  min-height: 100vh;
  img {
    width: 190px;
    margin-bottom: 0.2rem;
  }
}
</style>
